import { apiClient as api } from './client';

export interface CreditTransaction {
  transaction_id: string;
  user_id: string;
  planet_id: string | null;
  amount: number;
  type: 'AWARD' | 'SPEND' | 'REFUND' | 'ADJUST';
  source_platform: string | null;
  reason: string;
  balance_after: number;
  created_at: string;
}

export async function getTransactions(limit = 20): Promise<{ success: boolean; data: CreditTransaction[] }> {
  const res = await api.get(`/credits/transactions?limit=${limit}`);
  return res.data;
}
